import { geoMercator } from "d3-geo";

export const KOREA_MAP_WIDTH = 720;
export const KOREA_MAP_HEIGHT = 960;

export type ProjectedPoint = Readonly<{ x: number; y: number }>;

export function createKoreaProjection() {
  return geoMercator()
    .center([127.7, 36.1])
    .scale(6_000)
    .translate([KOREA_MAP_WIDTH / 2, KOREA_MAP_HEIGHT / 2]);
}

const koreaProjection = createKoreaProjection();

export function projectKorea(lon: number, lat: number): ProjectedPoint {
  if (!Number.isFinite(lon) || !Number.isFinite(lat)) {
    throw new Error("projection requires finite longitude and latitude");
  }
  const projected = koreaProjection([lon, lat]);
  if (!projected) throw new Error("projection returned no point");
  return Object.freeze({ x: projected[0], y: projected[1] });
}
